// // local 
// export const SSO_URL = "https://dev-api-supernotes.dwao.in/sso/User/login/super-tracker";
// export const SSO_CALLBACK_URL = "https://dev-api-supernotes.dwao.in/super-tracker/User/ssoCallback";
// export const API_BASE_URL = "https://dev-api-supernotes.dwao.in/super-tracker"; 



// dev 
export const SSO_URL = "https://dev-sso.dwao.in/User/login/super-tracker";
export const SSO_CALLBACK_URL = "https://dev-project.dwao.in/User/ssoCallback";
export const API_BASE_URL = "https://dev-project.dwao.in"; 



// prod
// export const SSO_URL = "https://sso.dwao.in/User/login/super-tracker";
// export const SSO_CALLBACK_URL = "https://project.dwao.in/User/ssoCallback";
// export const API_BASE_URL = "https://project.dwao.in"; 






// not in use 
// export const SSO_LOGIN_VIEW_URL = "https://dev-api-supernotes.dwao.in/sso/User/index"
